"use strict";
const carbucks = carbucks || {};

const exampleItems = document.querySelectorAll(".js-item-example");

carbucks.examples =
  carbucks.examples ||
  (function() {
    function init() {
      if (exampleItems && window.innerWidth < 992) {
        for (let i = 0; i < exampleItems.length; i++) {
          const current = exampleItems[i];

          current.addEventListener("click", function(e) {
            let clickedItem = e.currentTarget;
            clickedItem.classList.toggle("item-example--active");
          });
        }
      }
    }
    return {
      init: init,
    };
  })();
